import {useEffect} from 'react';
import {t} from 'i18next';
import {logout as logoutService} from '../../../api/Authentication';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import Typography from '@mui/material/Typography';
import {AuthPageLayout, redirectAfterLogout} from './shared';
import Box from '@mui/material/Box';

/**
 * Note: As part of this bug https://consilio.atlassian.net/browse/ARHD-11188
 * This component is no more in use for logout flow
 */
export const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    logoutService(dispatch);
    redirectAfterLogout(navigate);
  }, []);

  return (
    <AuthPageLayout>
      <Box className="login-form">
        <div className="login-content">
          <Typography className="typo-text headline2_size mist-color">
            {t('auth.login.logoutMsg1')}
            <br />
            {t('auth.login.logoutMsg2')}
          </Typography>
        </div>
      </Box>
    </AuthPageLayout>
  );
};
